import { render } from "./SimplePerfSkin.vue?vue&type=template&id=4e2dc30a&scoped=true&ts=true"
import script from "./SimplePerfSkin.vue?vue&type=script&lang=ts"
export * from "./SimplePerfSkin.vue?vue&type=script&lang=ts"

import "./SimplePerfSkin.vue?vue&type=style&index=0&id=4e2dc30a&scoped=true&lang=css"
import "./SimplePerfSkin.vue?vue&type=style&index=1&id=4e2dc30a&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2dc30a"]])

export default __exports__